import { render } from "./PAddVideoPrivate.vue?vue&type=template&id=38edce7c"
import script from "./PAddVideoPrivate.vue?vue&type=script&lang=js"
export * from "./PAddVideoPrivate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__